import {userService} from "@/_services/user.service";
import {API_URL} from "../config/app";

const URL = API_URL

export const localVerificationService = {
  show,
  sendOtp,
  verifyOtp
};

function show(signatureId, signatureFlowId, uuid) {
  const requestOptions = {
    method: 'GET',
  };

  return fetch(URL + "/signatures/" + signatureId + "/signature_flows/" + signatureFlowId + "/local_verifications/" + uuid, requestOptions)
    .then(handleResponse)
    .then(response => {
      return response
    })
}

function sendOtp(signatureId, signatureFlowId, uuid, phoneNumber) {
  const requestOptions = {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({phoneNumber})
  };

  return fetch(URL + "/signatures/" + signatureId + "/signature_flows/" + signatureFlowId + "/local_verifications/" + uuid + "/send-otp", requestOptions)
    .then(handleResponse)
    .then(response => {
      return response
    })
}

function verifyOtp(signatureId, signatureFlowId, uuid, otp, name, curp, latitude, longitude) {
  const requestOptions = {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({otp, name, curp, latitude, longitude})
  };

  return fetch(URL + "/signatures/" + signatureId + "/signature_flows/" + signatureFlowId + "/local_verifications/" + uuid + "/verify-otp", requestOptions)
    .then(handleResponse)
    .then(response => {
      return response
    })
}

function handleResponse(response) {
  return response.text().then(text => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        userService.refreshToken();
        return Promise.reject("Intentando recuperar la sesión");
      }

      const error = (data && data.errors[0].detail) || response.statusText;
      return Promise.reject(error);
    }
    return data;
  });
}
